import {Bm} from '../../../../graphql/generated/types';

/**
 * 미리보기(무료BM, 복합BM) 에 해당하는지 확인
 */
export function isPreviewBm(bm: Bm) {
  return [Bm.FreePreview, Bm.Free, Bm.MixedPay, Bm.MixedWaitfree].includes(bm);
}
